import {
  calculateInvoiceTotals,
  calculateQuoteTotals,
} from '@/js/shared/billables/client_document_totals';
import { calculateRefundTotals } from '@/js/shared/billables/refund_totals';
import { calculateRetainerTotals } from '@/js/shared/billables/retainer_totals';
import { calculatePurchaseOrderTotals } from '@/js/shared/billables/vendor_document_totals';

const strategies = {
  invoice: calculateInvoiceTotals,
  quote: calculateQuoteTotals,
  refund: calculateRefundTotals,
  retainer: calculateRetainerTotals,
  purchase_order: calculatePurchaseOrderTotals,
};

export function calculateBillableTotals(strategy, state) {
  const calculate = strategies[strategy];

  if (!calculate) {
    throw new Error(`Unknown calculation strategy: ${strategy}`);
  }

  return calculate(state);
}
